<div class="wk-reassign-task-dialog" *ngIf="!data.invalidDocumentsList.length; else failValidation">
  <header mat-dialog-header>
    <h3 class="upload-title">{{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.TITLE' | translate }}</h3>
    <span class="wk-icon-close" (click)="closeDialog()" (keyup)="closeDialog()"></span>
  </header>

  <p class="upload-desc">
    {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.DESCRIPTION' | translate }} {{ workflowName }}
  </p>

  <mat-accordion multi="false" class="wk-reassign-task-accordion">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header [expandedHeight]="expandedFilterPanelHeight">
        <mat-panel-title>
          {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.WORKFLOW_DIAGRAM' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div *ngIf="diagramImgUrl; else noDiagram" class="diagram">
        <img
          class="show-diagram__image"
          [src]="diagramImgUrl | safeResourceUrl"
          [alt]="'APP.BROWSE.PROCESS-SUMMARY.DIAGRAM_IMG_TEXT' | translate"
        />
      </div>

      <ng-template #noDiagram>
        <div class="task-progress-loading-spinner">
          <mat-progress-spinner color="primary" mode="indeterminate" [value]="80">
          </mat-progress-spinner>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>

  <hr class="adf-share-link__separation-line" />

  <form [formGroup]="reassignTaskGroup">
    <label class="wk-field-label" for="currentStepName_id">
      {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.CURRENT_STEP' | translate }}
    </label>
    <mat-form-field class="adf-task-form">
      <input
        matInput
        id="currentStepName_id"
        formControlName="currentStepName"
        placeholder="{{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.CURRENT_STEP_PLACEHOLDER' | translate }}"
        [value]="currentStepName"
      />
    </mat-form-field>

    <label class="wk-field-label" for="newAssignee">
      {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.NEW_ASSIGNEE' | translate }}
      <span class="wk-required">*</span>
    </label>
    <wk-people
      #peopleWidget
      *ngIf="newAssigneeTaskField"
      [field]="newAssigneeTaskField"
      (peopleSelected)="setAssigneeId($event)"
      (keyup)="onAssigneeInputChange(peopleWidget)"
    ></wk-people>

    <ng-container *ngIf="nextStepList$ | async as nextStepList">
      <label class="wk-field-label" for="nextStep_id">
        {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.NEXT_STEP' | translate }}
        <span class="wk-required">*</span>
      </label>
      <mat-form-field class="adf-task-form">
        <mat-select
          id="nextStep_id"
          class="form-control"
          formControlName="nextStepKey"
          placeholder="{{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.NEW_ASSIGNEE_PLACEHOLDER' | translate }}"
        >
          <mat-option value="" disabled selected hidden>
            {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.FORM.CURRENT_STEP_PLACEHOLDER' | translate }}
          </mat-option>
          <mat-option *ngFor="let step of nextStepList.next" [value]="step.name">
            {{ step.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </form>
</div>

<ng-template #failValidation>
  <div class="wk-reassign-task-dialog">
    <header mat-dialog-header>
      <h3 class="upload-title">{{ 'TASK_REASSIGNMENT.DIALOG.FAILED.TITLE' | translate }}</h3>
      <span class="wk-icon-close" (click)="closeDialog()" (keyup)="closeDialog()"></span>
    </header>

    <div class="wk-notification wk-is-open wk-notification-warning" role="alert">
      <span class="wk-icon-filled-caution" aria-hidden="true"></span>
      <p class="wk-notification-title">
        {{ 'TASK_REASSIGNMENT.DIALOG.FAILED.DESCRIPTION.WARN_TITLE' | translate }}
      </p>
      <p class="wk-notification-content">
        {{ 'TASK_REASSIGNMENT.DIALOG.FAILED.DESCRIPTION.WARN_DESC' | translate }}
      </p>
    </div>

    <div class="wk-invalid-documents-list">
      <ng-container *ngIf="getDocumentsByReason('locked').length">
        <p class="wk-invalid-documents-group-label">{{ 'TASK_REASSIGNMENT.DIALOG.FAILED.GROUPS.LOCKED' | translate }}</p>
        <div class="wk-quote-container" *ngFor="let document of getDocumentsByReason('locked')">
          <blockquote class="wk-blockquote">{{ formatDocumentPath(document) }}</blockquote>
        </div>
      </ng-container>

      <ng-container *ngIf="getDocumentsByReason('not-in-process').length">
        <p class="wk-invalid-documents-group-label">{{ 'TASK_REASSIGNMENT.DIALOG.FAILED.GROUPS.NOT_IN_PROCESS' | translate }}</p>
        <div class="wk-quote-container" *ngFor="let document of getDocumentsByReason('not-in-process')">
          <blockquote class="wk-blockquote">{{ formatDocumentPath(document) }}</blockquote>
        </div>
      </ng-container>

      <ng-container *ngIf="getDocumentsByReason('conflicting').length">
        <p class="wk-invalid-documents-group-label">{{ 'TASK_REASSIGNMENT.DIALOG.FAILED.GROUPS.CONFLICTING' | translate }}</p>
        <div class="wk-quote-container" *ngFor="let document of getDocumentsByReason('conflicting')">
          <blockquote class="wk-blockquote">{{ formatDocumentPath(document) }}</blockquote>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<div mat-dialog-actions class="upload-dialog-actions">
  <button
    type="button"
    (click)="closeDialog()"
    class="wk-button wk-button-text"
    [ngClass]="{ cancel: !data.invalidDocumentsList.length, close: data.invalidDocumentsList.length }"
  >
    {{
      data.invalidDocumentsList.length
        ? ('TASK_REASSIGNMENT.DIALOG.FAILED.CLOSE' | translate)
        : ('TASK_REASSIGNMENT.DIALOG.SUCCESS.CANCEL' | translate)
    }}
  </button>
  <button
    type="button"
    [disabled]="isFormValid() || submitClicked"
    class="wk-button upload-btn"
    *ngIf="!data.invalidDocumentsList.length"
    (click)="confirmReassignTask()"
  >
    {{ 'TASK_REASSIGNMENT.DIALOG.SUCCESS.CONFIRM' | translate }}
  </button>
</div>